import { OpusJobsService } from './opus-jobs.service';

export const services: any[] = [OpusJobsService];

export * from './opus-jobs.service';
